module.exports = {
    settings: [
      {
        title: "My Hub",
        description:
          "Enable content curation and distribution to your teams.",
        type: "Hub",
        icon: ""
      },
      {
        title: "Global Contacts",
        description:
          "Share consolidated list of contacts with all users across your organization.",
        type: "Contact",  
        icon: ""
      }
    ]
  };
  